import { getMyBulkJobAPI } from "./Api";

export const bulkJobKey = (type, scope = "default") => `bulkPdfJob:${type}:${scope || "default"}`;

export function readBulkJob(type, scope) {
  try {
    return localStorage.getItem(bulkJobKey(type, scope));
  } catch {
    return null;
  }
}

export function writeBulkJob(type, scope, jobId) {
  localStorage.setItem(bulkJobKey(type, scope), jobId);
}

export function clearBulkJob(type, scope) {
  localStorage.removeItem(bulkJobKey(type, scope));
}

export async function restoreBulkJob(type, scope) {
  const saved = readBulkJob(type, scope);
  if (saved) return saved;
  try {
    const res = await getMyBulkJobAPI(type);
    const job = res?.jobs?.[0];
    if (!job || !["pending", "in_progress", "completed"].includes(job.status)) return null;
    const id = job.id || job.jobId;
    if (!id) return null;
    writeBulkJob(type, scope, id);
    return id;
  } catch {
    return null;
  }
}

export function saveBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
